import { Link } from 'react-router-dom';
import { Alert, Button, Typography } from 'antd';
import { ApiOutlined } from '@ant-design/icons';
import { useAuthStore } from '@presentation/stores/authStore';
import { paths } from '@app/routes/paths';

export const DashboardPage = () => {
  const user = useAuthStore((state) => state.user);

  return (
    <div className="mx-auto max-w-3xl px-6 py-16">
      {user && !user.emailVerifiedAt && (
        <Alert
          className="mb-6"
          type="warning"
          showIcon
          title="Please verify your email address."
          action={<Link to={paths.verifyEmailNotice}>Verify now</Link>}
        />
      )}
      <Typography.Title level={3}>Welcome{user ? `, ${user.name}` : ''}.</Typography.Title>
      <Typography.Text type="secondary">
        Open a workspace to build collections, send requests, and manage environments.
      </Typography.Text>
      <div className="mt-6">
        {user?.currentWorkspaceId ? (
          <Link to={paths.workbench(user.currentWorkspaceId)}>
            <Button type="primary" icon={<ApiOutlined />}>
              Open workbench
            </Button>
          </Link>
        ) : (
          <Link to={paths.workspaces}>
            <Button type="primary">Choose a workspace</Button>
          </Link>
        )}
      </div>
    </div>
  );
};
